export const RELIGIONS = ['Hindu', 'Sikh', 'Jain', 'Buddhist', 'Christian', 'Other'] as const;
export type Religion = typeof RELIGIONS[number];

export const MARITAL_STATUSES = ['Never Married', 'Divorced', 'Widowed', 'Awaiting Divorce', 'Separated'] as const;
export const JOB_TYPES = ['Government', 'Private', 'Self Employed', 'Business', 'Not Working'] as const;
export const BODY_TYPES = ['Slim', 'Athletic', 'Average', 'Heavy'] as const;
export const BLOOD_GROUPS = ['A+', 'A-', 'B+', 'B-', 'O+', 'O-', 'AB+', 'AB-'] as const;
export const MOTHER_TONGUES = ['Hindi', 'Punjabi', 'Marwari', 'Gujarati', 'Haryanvi', 'Rajasthani', 'Bhojpuri', 'Awadhi', 'Maithili', 'Marathi', 'Bengali', 'Odia', 'Tamil', 'Telugu', 'Kannada', 'Malayalam', 'Urdu', 'Other'] as const;
export const FAMILY_TYPES = ['Nuclear', 'Joint', 'Extended'] as const;
export const FAMILY_STATUS_OPTIONS = ['Middle Class', 'Upper Middle Class', 'Rich', 'Affluent'] as const;
export const FAMILY_VALUES = ['Traditional', 'Moderate', 'Liberal'] as const;
export const DIET_OPTIONS = ['Vegetarian', 'Non-Vegetarian', 'Eggetarian', 'Vegan', 'Jain'] as const;
export const SMOKING_OPTIONS = ['Non-Smoker', 'Occasional', 'Regular'] as const;
export const DRINKING_OPTIONS = ['Non-Drinker', 'Occasional', 'Regular'] as const;
export const INCOME_FILTER_OPTIONS: { label: string; value: number }[] = [
  { label: 'Any',     value: 0 },
  { label: '2+ LPA',  value: 200000 },
  { label: '5+ LPA',  value: 500000 },
  { label: '10+ LPA', value: 1000000 },
  { label: '15+ LPA', value: 1500000 },
  { label: '20+ LPA', value: 2000000 },
  { label: '30+ LPA', value: 3000000 },
  { label: '50+ LPA', value: 5000000 },
];

export const NAKSHATRA_OPTIONS = [
  'ASHWINI', 'BHARANI', 'KRITTIKA', 'ROHINI', 'MRIGASHIRSHA', 'ARDRA',
  'PUNARVASU', 'PUSHYA', 'ASHLESHA', 'MAGHA', 'PURVA_PHALGUNI', 'UTTARA_PHALGUNI',
  'HASTA', 'CHITRA', 'SWATI', 'VISHAKHA', 'ANURADHA', 'JYESHTHA',
  'MULA', 'PURVA_ASHADHA', 'UTTARA_ASHADHA', 'SHRAVANA', 'DHANISHTHA',
  'SHATABHISHA', 'PURVA_BHADRAPADA', 'UTTARA_BHADRAPADA', 'REVATI',
] as const;

export const NAKSHATRA_LABELS: Record<string, string> = {
  ASHWINI: 'Ashwini', BHARANI: 'Bharani', KRITTIKA: 'Krittika',
  ROHINI: 'Rohini', MRIGASHIRSHA: 'Mrigashirsha', ARDRA: 'Ardra',
  PUNARVASU: 'Punarvasu', PUSHYA: 'Pushya', ASHLESHA: 'Ashlesha',
  MAGHA: 'Magha', PURVA_PHALGUNI: 'Purva Phalguni', UTTARA_PHALGUNI: 'Uttara Phalguni',
  HASTA: 'Hasta', CHITRA: 'Chitra', SWATI: 'Swati',
  VISHAKHA: 'Vishakha', ANURADHA: 'Anuradha', JYESHTHA: 'Jyeshtha',
  MULA: 'Mula', PURVA_ASHADHA: 'Purva Ashadha', UTTARA_ASHADHA: 'Uttara Ashadha',
  SHRAVANA: 'Shravana', DHANISHTHA: 'Dhanishtha', SHATABHISHA: 'Shatabhisha',
  PURVA_BHADRAPADA: 'Purva Bhadrapada', UTTARA_BHADRAPADA: 'Uttara Bhadrapada', REVATI: 'Revati',
};

export const RASHI_OPTIONS = [
  'ARIES', 'TAURUS', 'GEMINI', 'CANCER', 'LEO', 'VIRGO',
  'LIBRA', 'SCORPIO', 'SAGITTARIUS', 'CAPRICORN', 'AQUARIUS', 'PISCES',
] as const;

export const RASHI_LABELS: Record<string, string> = {
  ARIES: 'Aries', TAURUS: 'Taurus', GEMINI: 'Gemini', CANCER: 'Cancer',
  LEO: 'Leo', VIRGO: 'Virgo', LIBRA: 'Libra', SCORPIO: 'Scorpio',
  SAGITTARIUS: 'Sagittarius', CAPRICORN: 'Capricorn', AQUARIUS: 'Aquarius', PISCES: 'Pisces',
};

export const INCOME_RANGES: { label: string; value: number }[] = [
  { label: 'Below 2 LPA',  value: 100000 },
  { label: '2–3 LPA',      value: 250000 },
  { label: '3–5 LPA',      value: 400000 },
  { label: '5–8 LPA',      value: 650000 },
  { label: '8–12 LPA',     value: 1000000 },
  { label: '12–20 LPA',    value: 1600000 },
  { label: '20–30 LPA',    value: 2500000 },
  { label: '30–50 LPA',    value: 4000000 },
  { label: '50 LPA+',      value: 5000000 },
];
